/**
 *  权限判断相关mixins
 * */
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      permissionsList: state => state.user.permissionsList
    })
  },
  methods: {
    /**
     * 对比权限
     * @userPermission 权限码，支持字符串和字符形式authorityComparison
     */
    comparePermissions(userPermission){
      if(!userPermission){
        return true;
      }
      return this.$authorityComparison(this.permissionsList, userPermission)
    },
  }
}
